/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MedicationStatementUpsertRequestDto
 */
export interface MedicationStatementUpsertRequestDto {
    /**
     * Medication statement ID (required for edit, omit for create)
     * @type {string}
     * @memberof MedicationStatementUpsertRequestDto
     */
    id?: string;
    /**
     * Medication name
     * @type {string}
     * @memberof MedicationStatementUpsertRequestDto
     */
    name: string;
    /**
     * Medication dose (e.g., '81 mg', '2 tablets')
     * @type {string}
     * @memberof MedicationStatementUpsertRequestDto
     */
    dose: string;
    /**
     * Frequency (e.g., 'once daily', 'twice daily')
     * @type {string}
     * @memberof MedicationStatementUpsertRequestDto
     */
    frequency: string;
    /**
     * Purpose or reason for medication
     * @type {string}
     * @memberof MedicationStatementUpsertRequestDto
     */
    purpose?: string;
    /**
     * Indicates if this update is part of onboarding flow
     * @type {boolean}
     * @memberof MedicationStatementUpsertRequestDto
     */
    isOnboarding?: boolean;
}

/**
 * Check if a given object implements the MedicationStatementUpsertRequestDto interface.
 */
export function instanceOfMedicationStatementUpsertRequestDto(value: object): value is MedicationStatementUpsertRequestDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('dose' in value) || value['dose'] === undefined) return false;
    if (!('frequency' in value) || value['frequency'] === undefined) return false;
    return true;
}

export function MedicationStatementUpsertRequestDtoFromJSON(json: any): MedicationStatementUpsertRequestDto {
    return MedicationStatementUpsertRequestDtoFromJSONTyped(json, false);
}

export function MedicationStatementUpsertRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicationStatementUpsertRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        'dose': json['dose'],
        'frequency': json['frequency'],
        'purpose': json['purpose'] == null ? undefined : json['purpose'],
        'isOnboarding': json['isOnboarding'] == null ? undefined : json['isOnboarding'],
    };
}

export function MedicationStatementUpsertRequestDtoToJSON(json: any): MedicationStatementUpsertRequestDto {
    return MedicationStatementUpsertRequestDtoToJSONTyped(json, false);
}

export function MedicationStatementUpsertRequestDtoToJSONTyped(value?: MedicationStatementUpsertRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'dose': value['dose'],
        'frequency': value['frequency'],
        'purpose': value['purpose'],
        'isOnboarding': value['isOnboarding'],
    };
}

